import { DropItem } from "./DropItem";
import Phaser from 'phaser';
import BaseLevelScene from "src/app/Scenes/BaseLevelScene";
import { BaseSpriteInterface } from "./SpriteInterfaces";

export interface StoryItemData extends BaseSpriteInterface{
  animationKey: string;
  name: string;
}

export class StoryItem extends Phaser.Physics.Matter.Sprite {
  static sound: Phaser.Sound.BaseSound;
  birthTime: number;
  minLifeSpan: number = 250; //(ms) Min time before this can be picked up
  animationKey: string;
  constructor(data: StoryItemData, playerScale=1) {
    let { scene, x, y, texture, animationKey, name } = data;
    super(scene.matter.world, x, y, texture, null);
    console.log('texture:');
    console.log(texture);
    console.log('animationKey:');
    console.log(animationKey);
    this.name = name;
    this.animationKey = animationKey;
    this.scene.add.existing(this);
    const Bodies = new Phaser.Physics.Matter.MatterPhysics(scene).bodies;
    var circleCollider = Bodies.circle(this.x, this.y, 20*playerScale, {
      isSensor: true,
      label: 'storyItemSensor',
    });
    this.setExistingBody(circleCollider);
    this.setFrictionAir(1);
    this.setScale(playerScale);
    this.setDepth(0);
    this.birthTime = Date.now();
    this.anims.play(animationKey, true);
    this.setVisible(true);
  }

  static preload(scene) {
    // Load gem data
    scene.load.atlas(
      'gems',
      'assets/items/gems.png',
      'assets/items/gems_atlas.json'
    );
    scene.load.animation('gems_anims', 'assets/items/gems_anim.json');

    // Load heart gem data
    scene.load.atlas(
      'heart_gem',
      'assets/items/heart_gem.png',
      'assets/items/heart_gem_atlas.json'
    );
    scene.load.animation('heart_gem_anims', 'assets/items/heart_gem_anim.json');
  }

  pickup() {
    console.log("Story Item pickup!");
    const overlay = (this.scene as BaseLevelScene)?.overlay;
    let overlapsWithOverlayBody: boolean = false;
    if(overlay){
      const activeTiles = overlay.culledTiles.filter((tile) => {return tile.physics['matterBody'] ? true : false});
      if(activeTiles){
        const overlayTileBodies = activeTiles.map((tile) => {return tile.physics['matterBody']}) as Phaser.Types.Physics.Matter.MatterBody[];
        overlapsWithOverlayBody = this.scene.matter.overlap(this, overlayTileBodies);
      }
    }
    if (Date.now() - this.birthTime >= this.minLifeSpan && !overlapsWithOverlayBody) {
      DropItem.sound.play();
      this.destroy();
      return true;
    }
    return false;
  }
}
